export const NORWEGIAN_TRANSLATIONS = {
  title: 'Tittel',
  description: 'Beskrivelse',
  titleAndDescription: 'Overskrift og beskrivelse',
  overview: 'Oversikt',
  generalInfo: 'Generell info',
  whatToBring: 'Hva bør man ha med',
  additionalInfo: 'Tilleggsinformasjon',
  cancellation: 'Avbestillingsbetingelser',
  included: 'Inkludert',
  notIncluded: 'Ikke inkuldert',
  bedDetails: 'Sengetype',
  fee: 'Gebyrer',

  titleIsRequired: 'Tittel er påkrevd',
  overviewIsRequired: 'Oversikt er påkrevd',
  cancellationIsRequired: 'Avbestillingsbetingelser er påkrevd',
  cancellationHelpMessage: `Her må du fylle ut vilkårene for kansellering, og eventuell varighet for en 
  pass-aktivitet. For eksempel: "Du kan kansellere gratis opp til 48 timer før aktivitetens tidspunkt, alle 
  andre kanselleringer er ikke refunderbare".`,
  includedHelpMessage: `Trykk på enter for hvert element. Merk at hvis du skriver inn teksten, 
  men ikke trykker på enter, vil ikke elementet bli lagret.`,
  'Hit Enter to add an item': 'Trykk Enter for å legge til et element'
};
